import { render } from "./TmpPatients.vue?vue&type=template&id=7feeda66&scoped=true"
import script from "./TmpPatients.vue?vue&type=script&lang=js"
export * from "./TmpPatients.vue?vue&type=script&lang=js"

import "./TmpPatients.vue?vue&type=style&index=0&id=7feeda66&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7feeda66"]])

export default __exports__